import { Link } from "@/components/LocalizedLink"
import { resolveNavLink } from "@/utils/navigation"

export interface BannerContentProps {
  name: string
  description?: string | null
  button?: {
    label: string
    type: string
    openInNewTab: boolean
    url: string
    linkRef: { value: string; entity: string; slug?: string | null } | string | null
  } | null
}

export default function BannerContent({ name, description, button }: BannerContentProps) {
  const resolvedLink = button ? resolveNavLink(button) : { url: '#', isExternal: false }

  return (
    <div className="flex flex-col gap-2 md:gap-3 px-8 py-6 w-full items-center md:items-start md:w-fit">
      <h2 className="text-4xl font-bold text-white text-shadow-md">{name}</h2>
      {description && <div className="text-lg text-white max-w-sm text-shadow-md prose prose-invert prose-p:my-1" dangerouslySetInnerHTML={{ __html: description }} />}
      {button && button.label && (
        <Link
          to={resolvedLink.url}
          target={resolvedLink.isExternal ? '_blank' : '_self'}
          rel={resolvedLink.isExternal ? 'noopener noreferrer' : undefined}
          className="inline-block max-w-fit px-6 py-2 bg-primary text-on-primary rounded-md shadow-sm font-medium hover:bg-primary/90 transition-colors">
          {button.label}
        </Link>
      )
      }
    </div>
  )
}